// extracted by mini-css-extract-plugin
module.exports = {"gpDetailsContainer":"GPDetails_gpDetailsContainer__1A2ed","title":"GPDetails_title__7e8S2","noGPTitle":"GPDetails_noGPTitle__3rHQP"};